/**
 * @generated SignedSource<<9e4d6b6379280bbf391f7e2d315a8c2a>>
 * @relayHash 389fdeea048c66525e3cec717b045093
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb

import type { ConcreteRequest, Query } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type JiraConfigStateConfigurationStatus = "CONFIGURED" | "NOT_CONFIGURED" | "NOT_INSTALLED" | "NOT_SET" | "PARTIALLY_CONFIGURED" | "PROVIDER_ACTION_CONFIGURED" | "PROVIDER_ACTION_NOT_CONFIGURED" | "%future added value";
export type mainCodeInJiraUpdatedQuery$variables = {
  cloudId: string;
  numPullRequestsToFetch: number;
  projectKey: string;
  pullRequestsUpdatedFrom: AGG$DateTime;
  siteAri: string;
};
export type mainCodeInJiraUpdatedQuery$data = {
  readonly codeInJira: {
    readonly userConfiguration: {
      readonly ownedBitbucketWorkspaces: ReadonlyArray<{
        readonly __typename: "CodeInJiraBitbucketWorkspace";
      } | null | undefined>;
    };
  };
  readonly devOps: {
    readonly providers: {
      readonly devInfoProviders: ReadonlyArray<{
        readonly __typename: "DevOpsDevInfoProvider";
        readonly configState: {
          readonly config: {
            readonly nodes: ReadonlyArray<{
              readonly appId: string;
              readonly status: JiraConfigStateConfigurationStatus | null | undefined;
            }> | null | undefined;
          } | null | undefined;
        } | null | undefined;
        readonly name: string | null | undefined;
      } | null | undefined> | null | undefined;
    };
  };
  readonly jira: {
    readonly devOps: {
      readonly configState: {
        readonly config: {
          readonly nodes: ReadonlyArray<{
            readonly appId: string;
            readonly status: JiraConfigStateConfigurationStatus | null | undefined;
          }> | null | undefined;
        } | null | undefined;
      } | null | undefined;
    } | null | undefined;
    readonly jiraProjectByKey: {
      readonly repositories: {
        readonly edges: ReadonlyArray<{
          readonly __typename: "GraphStoreSimplifiedProjectAssociatedRepoEdge";
        } | null | undefined> | null | undefined;
      } | null | undefined;
    } | null | undefined;
  } | null | undefined;
  readonly " $fragmentSpreads": FragmentRefs<"main_softwareCodePage_ConnectionPage" | "main_softwareCodePage_Header" | "main_softwareCodePage_MainPage">;
};
export type mainCodeInJiraUpdatedQuery = {
  response: mainCodeInJiraUpdatedQuery$data;
  variables: mainCodeInJiraUpdatedQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "cloudId"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "numPullRequestsToFetch"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "projectKey"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "pullRequestsUpdatedFrom"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "siteAri"
},
v5 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "siteAri"
  },
  {
    "kind": "Literal",
    "name": "providerTypes",
    "value": [
      "DEV_INFO"
    ]
  }
],
v6 = {
  "kind": "ScalarField",
  "name": "name"
},
v7 = {
  "kind": "ScalarField",
  "name": "__typename"
},
v8 = {
  "kind": "Variable",
  "name": "cloudId",
  "variableName": "cloudId"
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "kind": "ScalarField",
  "name": "status"
},
v11 = {
  "concreteType": "JiraConfigStateConnection",
  "kind": "LinkedField",
  "name": "config",
  "plural": false,
  "selections": [
    {
      "concreteType": "JiraConfigState",
      "kind": "LinkedField",
      "name": "nodes",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "name": "appId"
        },
        (v10/*: any*/)
      ]
    }
  ]
},
v12 = [
  (v11/*: any*/)
],
v13 = [
  (v7/*: any*/)
],
v14 = [
  {
    "kind": "Literal",
    "name": "appId",
    "value": "bitbucket"
  },
  (v8/*: any*/)
],
v15 = [
  (v8/*: any*/),
  {
    "kind": "Variable",
    "name": "key",
    "variableName": "projectKey"
  }
],
v16 = [
  {
    "kind": "Literal",
    "name": "sort",
    "value": {
      "lastModified": {
        "direction": "DESC",
        "priority": 1
      }
    }
  }
],
v17 = {
  "kind": "ScalarField",
  "name": "id"
},
v18 = [
  (v11/*: any*/),
  (v17/*: any*/)
],
v19 = {
  "kind": "ScalarField",
  "name": "lastUpdated"
},
v20 = {
  "kind": "ScalarField",
  "name": "url"
},
v21 = [
  (v17/*: any*/)
],
v22 = {
  "kind": "InlineFragment",
  "selections": (v21/*: any*/),
  "type": "Node",
  "abstractKey": "__isNode"
},
v23 = [
  (v7/*: any*/),
  {
    "kind": "ScalarField",
    "name": "accountId"
  },
  (v6/*: any*/),
  {
    "kind": "ScalarField",
    "name": "picture"
  },
  (v17/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Fragment",
    "name": "mainCodeInJiraUpdatedQuery",
    "selections": [
      {
        "kind": "RequiredField",
        "field": {
          "concreteType": "DevOps",
          "kind": "LinkedField",
          "name": "devOps",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "args": (v5/*: any*/),
                "concreteType": "DevOpsProviders",
                "kind": "LinkedField",
                "name": "providers",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "DevOpsDevInfoProvider",
                    "kind": "LinkedField",
                    "name": "devInfoProviders",
                    "plural": true,
                    "selections": [
                      (v6/*: any*/),
                      (v7/*: any*/),
                      {
                        "args": (v9/*: any*/),
                        "concreteType": "JiraAppConfigState",
                        "kind": "LinkedField",
                        "name": "configState",
                        "plural": false,
                        "selections": (v12/*: any*/)
                      }
                    ]
                  }
                ]
              },
              "action": "THROW",
              "path": "devOps.providers"
            }
          ]
        },
        "action": "THROW",
        "path": "devOps"
      },
      {
        "kind": "RequiredField",
        "field": {
          "args": (v9/*: any*/),
          "concreteType": "CodeInJira",
          "kind": "LinkedField",
          "name": "codeInJira",
          "plural": false,
          "selections": [
            {
              "kind": "RequiredField",
              "field": {
                "concreteType": "CodeInJiraUserConfiguration",
                "kind": "LinkedField",
                "name": "userConfiguration",
                "plural": false,
                "selections": [
                  {
                    "kind": "RequiredField",
                    "field": {
                      "concreteType": "CodeInJiraBitbucketWorkspace",
                      "kind": "LinkedField",
                      "name": "ownedBitbucketWorkspaces",
                      "plural": true,
                      "selections": (v13/*: any*/)
                    },
                    "action": "THROW",
                    "path": "codeInJira.userConfiguration.ownedBitbucketWorkspaces"
                  }
                ]
              },
              "action": "THROW",
              "path": "codeInJira.userConfiguration"
            }
          ]
        },
        "action": "THROW",
        "path": "codeInJira"
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v14/*: any*/),
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": (v12/*: any*/)
              }
            ]
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v16/*: any*/),
                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                "kind": "LinkedField",
                "name": "repositories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": (v13/*: any*/)
                  }
                ],
                "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
              }
            ]
          }
        ]
      },
      {
        "kind": "FragmentSpread",
        "name": "main_softwareCodePage_MainPage"
      },
      {
        "kind": "FragmentSpread",
        "name": "main_softwareCodePage_Header"
      },
      {
        "kind": "FragmentSpread",
        "name": "main_softwareCodePage_ConnectionPage"
      }
    ],
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v2/*: any*/),
      (v1/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/)
    ],
    "kind": "Operation",
    "name": "mainCodeInJiraUpdatedQuery",
    "selections": [
      {
        "concreteType": "DevOps",
        "kind": "LinkedField",
        "name": "devOps",
        "plural": false,
        "selections": [
          {
            "args": (v5/*: any*/),
            "concreteType": "DevOpsProviders",
            "kind": "LinkedField",
            "name": "providers",
            "plural": false,
            "selections": [
              {
                "concreteType": "DevOpsDevInfoProvider",
                "kind": "LinkedField",
                "name": "devInfoProviders",
                "plural": true,
                "selections": [
                  (v6/*: any*/),
                  (v7/*: any*/),
                  {
                    "args": (v9/*: any*/),
                    "concreteType": "JiraAppConfigState",
                    "kind": "LinkedField",
                    "name": "configState",
                    "plural": false,
                    "selections": (v18/*: any*/)
                  },
                  (v17/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "homeUrl"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "namespace"
                  }
                ]
              }
            ]
          }
        ]
      },
      {
        "args": (v9/*: any*/),
        "concreteType": "CodeInJira",
        "kind": "LinkedField",
        "name": "codeInJira",
        "plural": false,
        "selections": [
          {
            "concreteType": "CodeInJiraUserConfiguration",
            "kind": "LinkedField",
            "name": "userConfiguration",
            "plural": false,
            "selections": [
              {
                "concreteType": "CodeInJiraBitbucketWorkspace",
                "kind": "LinkedField",
                "name": "ownedBitbucketWorkspaces",
                "plural": true,
                "selections": [
                  (v7/*: any*/),
                  {
                    "kind": "ScalarField",
                    "name": "uuid"
                  },
                  {
                    "kind": "ScalarField",
                    "name": "slug"
                  },
                  (v6/*: any*/)
                ]
              }
            ]
          }
        ]
      },
      {
        "concreteType": "JiraQuery",
        "kind": "LinkedField",
        "name": "jira",
        "plural": false,
        "selections": [
          {
            "concreteType": "JiraDevOpsQuery",
            "kind": "LinkedField",
            "name": "devOps",
            "plural": false,
            "selections": [
              {
                "args": (v14/*: any*/),
                "concreteType": "JiraAppConfigState",
                "kind": "LinkedField",
                "name": "configState",
                "plural": false,
                "selections": (v18/*: any*/)
              }
            ]
          },
          {
            "args": (v15/*: any*/),
            "concreteType": "JiraProject",
            "kind": "LinkedField",
            "name": "jiraProjectByKey",
            "plural": false,
            "selections": [
              {
                "args": (v16/*: any*/),
                "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoConnection",
                "kind": "LinkedField",
                "name": "repositories",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "GraphStoreSimplifiedProjectAssociatedRepoEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      (v7/*: any*/),
                      (v17/*: any*/),
                      (v19/*: any*/),
                      {
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v7/*: any*/),
                          {
                            "kind": "InlineFragment",
                            "selections": [
                              (v17/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "providerId"
                              },
                              (v6/*: any*/),
                              {
                                "kind": "ScalarField",
                                "name": "avatarUrl"
                              },
                              (v20/*: any*/)
                            ],
                            "type": "DevOpsRepository"
                          },
                          (v22/*: any*/)
                        ]
                      }
                    ]
                  }
                ],
                "storageKey": "repositories(sort:{\"lastModified\":{\"direction\":\"DESC\",\"priority\":1}})"
              },
              (v17/*: any*/),
              {
                "args": [
                  {
                    "fields": [
                      {
                        "kind": "Variable",
                        "name": "updatedFrom",
                        "variableName": "pullRequestsUpdatedFrom"
                      }
                    ],
                    "kind": "ObjectValue",
                    "name": "filter"
                  },
                  {
                    "kind": "Variable",
                    "name": "first",
                    "variableName": "numPullRequestsToFetch"
                  },
                  {
                    "kind": "Literal",
                    "name": "sort",
                    "value": {
                      "lastUpdatedSortDirection": "DESC"
                    }
                  },
                  {
                    "kind": "Literal",
                    "name": "type",
                    "value": "project-associated-pr"
                  }
                ],
                "concreteType": "AriGraphRelationshipConnection",
                "kind": "LinkedField",
                "name": "devOpsEntityRelationships",
                "plural": false,
                "selections": [
                  {
                    "concreteType": "AriGraphRelationshipEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "concreteType": "AriGraphRelationship",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "concreteType": "AriGraphRelationshipNode",
                            "kind": "LinkedField",
                            "name": "to",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "name": "data",
                                "plural": false,
                                "selections": [
                                  (v7/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": [
                                      (v10/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "repositoryName"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "repositoryId"
                                      },
                                      {
                                        "kind": "LinkedField",
                                        "name": "author",
                                        "plural": false,
                                        "selections": (v23/*: any*/)
                                      },
                                      {
                                        "concreteType": "DevOpsReviewer",
                                        "kind": "LinkedField",
                                        "name": "reviewers",
                                        "plural": true,
                                        "selections": [
                                          {
                                            "kind": "LinkedField",
                                            "name": "user",
                                            "plural": false,
                                            "selections": (v23/*: any*/)
                                          },
                                          (v7/*: any*/),
                                          {
                                            "kind": "ScalarField",
                                            "name": "approvalStatus"
                                          },
                                          {
                                            "kind": "ScalarField",
                                            "name": "userId"
                                          }
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "title"
                                      },
                                      (v17/*: any*/),
                                      (v19/*: any*/),
                                      {
                                        "kind": "ScalarField",
                                        "name": "commentCount"
                                      },
                                      (v20/*: any*/),
                                      {
                                        "concreteType": "DevOpsBranchInfo",
                                        "kind": "LinkedField",
                                        "name": "destinationBranch",
                                        "plural": false,
                                        "selections": [
                                          (v6/*: any*/),
                                          (v20/*: any*/)
                                        ]
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "pullRequestInternalId"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "repositoryUrl"
                                      },
                                      {
                                        "kind": "ScalarField",
                                        "name": "authorId"
                                      }
                                    ],
                                    "type": "DevOpsPullRequestDetails"
                                  },
                                  (v22/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "DevOpsFeatureFlag"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "DevOpsOperationsComponentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "DevOpsOperationsIncidentDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "DevOpsOperationsPostIncidentReviewDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "DevOpsRepository"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "DevOpsSecurityVulnerabilityDetails"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "JiraAutodevJob"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "JiraConfluenceRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "JiraCustomRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "JiraIssueRemoteIssueLink"
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "selections": (v21/*: any*/),
                                    "type": "JiraWebRemoteIssueLink"
                                  }
                                ]
                              },
                              (v17/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  {
                    "concreteType": "PageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "ScalarField",
                        "name": "hasNextPage"
                      }
                    ]
                  }
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "id": "065a174c5747d32e4ac04da08516b772ae16f6995b07756d19cd3af74fa4c4bb",
    "metadata": {},
    "name": "mainCodeInJiraUpdatedQuery",
    "operationKind": "query",
    "text": null
  }
};
})();

(node as any).hash = "e7b0f6a6904c8a1f0dcd2b6cc16ebe99";

export default node;
